export class EmptyBody {}
